module.exports = __webpack_public_path__ + "static/media/Aboutbanner.23ccc51f.jpg";